
export class AdminConst {
  public static headerTableUsers = [
    { field: 'username', title: 'Correo', cell: (row) => `${row.username}`, class: (row) => `` },
    { field: 'companyName', title: 'Nombre', cell: (row) => `${row.companyName}`, class: (row) => `` },
    { field: 'createdAt', title: 'Fecha registro', cell: (row) => `${new Date(row.createdAt).toLocaleDateString()}`, class: (row) => `` },
    { field: 'isActivated', title: 'Activado', cell: (row) => row.isActivated ? `Si` : `No`, class: (row) => row.isActivated ? `paid` : `notPaid` },
    { field: 'isConsultant', title: 'Asesoria', cell: (row) => row.isConsultant ? `Si` : `No`, class: (row) => row.isConsultant ? `paid` : `notPaid` },
    { field: 'isBusinessGroup', title: 'Grupo empresarial', cell: (row) => row.isBusinessGroup ? `Si` : `No`, class: (row) => row.isBusinessGroup ? `paid` : `notPaid` },
    { field: 'subscriptionName', title: 'Suscripción', cell: (row) => `${row.subscriptionName}`, class: (row) => `` },
    { field: 'phone', title: 'Telefono', cell: (row) => `${row.phone}`, class: (row) => `` },
    { field: 'commentsPanelAdminCustom', title: 'Comentarios', cell: (row) => `${row.commentsPanelAdminCustom}`, class: (row) => `` },
  ];

  public static headerTableLogs = [
    { field: 'dateException', title: 'Fecha', cell: (row) => `${row.dateException}`, class: (row) => `` },
    { field: 'versionBackend', title: 'Versión Backend', cell: (row) => `${row.versionBackend}`, class: (row) => `` },
    { field: 'userName', title: 'Usuario', cell: (row) => `${row.userName}`, class: (row) => `` },
    { field: 'method', title: 'Metodo', cell: (row) => `${row.method}`, class: (row) => `` },
    { field: 'messageException', title: 'Mensaje', cell: (row) => `${row.messageException}`, class: (row) => `` },
  ];

  public static headerTableHelp = [
    { field: 'cultureId', title: 'Culture', cell: (row) => `${row.cultureId}`, class: (row) => `` },
    { field: 'parent', title: 'Sección', cell: (row) => `${row.parent}`, class: (row) => `` },
    { field: 'section', title: 'Elemento', cell: (row) => `${row.section}`, class: (row) => `` },
    { field: 'description', title: 'Descripción', cell: (row) => `${row.description}`, class: (row) => `` },
    { field: 'keyword', title: 'Key', cell: (row) => `${row.keyword}`, class: (row) => `` },

  ];

  public static headerTableEvents = [
    {
      field: 'DateAdded', title: 'Fecha', cell: (row) => `${new Date(row.dateAdded).toLocaleString()}`,
      class: (row) => ``
    },
    { field: 'OwnerId', title: 'Usuario Id', cell: (row) => `${row.ownerId}`, class: (row) => `` },
    { field: 'EventType', title: 'Tipo Evento', cell: (row) => `${row.eventType}`, class: (row) => `` },
    { field: 'MetaData', title: 'MetaData', cell: (row) => `${row.metaData}`, class: (row) => `` },
  ];

  public static headerTableContacts = [
    {
      field: 'isClient', title: 'Tipo', cell: (row) =>
        row.isClient && row.isProvider ? 'Cliente - Proveedor/Acreedor' : row.isClient && !row.isProvider ? 'Cliente' : !row.isClient && row.isProvider ? 'Proveedor/Acreedor' : ''
      , class: (row) => ``
    },
    { field: 'companyName', title: 'Nombre', cell: (row) => `${row.companyName}`, class: (row) => `` },
    {
      field: 'vatNumber', title: 'CIF/NIF', cell: (row) =>
        row.vatNumber === '0000000' ? `` : `${row.vatNumber}`, class: (row) => ``
    },
    { field: 'email', title: 'Email', cell: (row) => row.email ? `${row.email}` : ``, class: (row) => `` },
    { field: 'phone', title: 'Teléfono', cell: (row) => row.phone ? `${row.phone}` : ``, class: (row) => `` },
  ];

  public static headerTableSupportTicket = [
    { field: 'name', title: 'Usuario', cell: (row) => `${row.Name}`, class: (row) => `` },
    { field: 'category', title: 'Categoría', cell: (row) => `${row.Category}`, class: (row) => `` },
    { field: 'resolved', title: 'Estado', cell: (row) => `${row.resolved}`, class: (row) => `` },
    { field: 'priority', title: 'Prioridad', cell: (row) => `${row.priority}`, class: (row) => `` },
    { field: 'subject', title: 'Asunto', cell: (row) => `${row.subject}`, class: (row) => `` },
    { field: 'date', title: 'Fecha', cell: (row) => `${new Date(row.date).toLocaleDateString()}`, class: (row) => `` },

  ];
}
